export default function PaymentInfoPage() {
  return <div>PaymentInfoPage</div>;
}
